import { ButtonOverrides, TextOverrides } from './content-overrides.types';
import { PageModule, PageModuleType } from './module.types';
import { HeaderAllTemplates } from './template-layouts.types';
import { TranslateString } from './translation.types';

export interface EventHomepage {
  homepage: number;
  header: HomepageHeader; //lives only within this event - does not require a connection to another collection
  use_header: boolean; //keep data and on/off separate in case user toggles them on/off we don't want to lose data
  footer: HomepageFooter;
  use_footer: boolean;
  modules: PageModule[];
  post_register_home_modules: PageModule[];
  languages: string[]; // should eventually use LanguagesAbbr instead
  event_main_nav_items?: IHomepageMainNavItems[];
  event_profile_nav_items?: IHomepageProfileNavItems[];
  // New parameters must be optional or nullable
}

export interface HomepageHeader {
  logo: string | null;
  layout: HeaderAllTemplates;
  is_sticky?: boolean;
  navItems: CallToAction[];
  callToAction: CallToAction;
  styling_overrides?: {
    background?: {
      color: string;
      image: {
        is_on: boolean;
        src: string;
      };
    };
    content?: {
      navItems?: TextOverrides;
      callToAction: ButtonOverrides;
    };
  };
  sign_in_button?: boolean;
  // New parameters must be optional or nullable
}

export interface HomepageFooter {
  logo: string | null;
  navItems: CallToAction[];
  styling_overrides?: {
    background?: {
      color: string;
      image: {
        is_on: boolean;
        src: string;
      };
    };
    content?: {
      navItems?: TextOverrides;
      blLogoColor?: string;
    };
  };
  // New parameters must be optional or nullable
}

export interface IHomepageMainNavItems {
  uuid: string;
  name: NavMainItems;
  custom_name: TranslateString;
  is_on: boolean;
  custom_icon_uuid?: string;
  is_custom?: boolean;
  // New parameters must be optional or nullable
}

export enum ENavbarTypes {
  Vertical = 'vertical_v2',
  Horizontal = 'horizontal_v2',
  VerticalOriginal = 'vertical-original',
}

export interface IHomepageProfileNavItems {
  uuid: string;
  name: NavProfileItems;
  custom_name: TranslateString;
  is_on: boolean;
  custom_icon_uuid?: string;
  is_custom?: boolean;
  // New parameters must be optional or nullable
}

export interface CallToAction {
  id?: string;
  type: CallToActionType;
  button_name: TranslateString;
  content: {
    isOn?: boolean /** not used for header NavItems, items that are off are simply removed from the list */;
    section?: PageModuleType /** @deprecated use section_module_id instead. section uses module type and is used only for backwards compatabliity as of the writing of this (2022-05-05). It will not exists in any future modules moving forward */;
    section_module_id?: number;
    page?: PageLinkType;
    url?: string;
    session?: string /** session uuid */;
  };
  // New parameters must be optional or nullable
}

export enum CallToActionType {
  section, //module to link to (e.g. speakers, agenda)
  page, //e.g. registration, termsAndConditions
  url,
  session, // links to selected session
  registrationForm,
}

export enum PageLinkType {
  //if more page links are needed add them here and call-to-action.tsx
  registration = 'registration',
  landing = 'landing',
  termsAndConditions = 'terms-and-conditions',
  privacyPolicy = 'privacy-policy',
  homepage = 'homepage',
  agenda = 'agenda',
}

export enum NavProfileItems {
  Profile = 'Profile',
  TermsAndConditions = 'Terms and Conditions',
  PrivacyPolicy = 'Privacy Policy',
  Social = 'Socials',
  Leaderboard = 'Leaderboard',
  GDPRSettings = 'GDPR',
}

export enum NavMainItems {
  Home = 'Home',
  Sessions = 'Sessions',
  Session = 'Session', // for single session events
  TellyClub = 'Telly Club',
  Notifications = 'Notifications',
  People = 'People', // now Directory, keeping for backwards compat
  Directory = 'Directory', // Previously People
  Catalog = 'Catalog',
  Social = 'Socials',
  Leaderboard = 'Leaderboard',
}

export interface IPostRegisterHomeModule {
  is_on: boolean;
  module_id: number;
}

export interface DBEventHomepage {
  homepage: number;
  header: HomepageHeader; //lives only within this event - does not require a connection to another collection
  use_header: boolean; //keep data and on/off separate in case user toggles them on/off we don't want to lose data
  footer: HomepageFooter;
  use_footer: boolean;
  modules: number[];
  post_register_home_modules?: IPostRegisterHomeModule[];
  languages: string[];
  event_main_nav_items?: IHomepageMainNavItems[];
  event_profile_nav_items?: IHomepageProfileNavItems[];
  // New parameters must be optional or nullable
}
